import Module from '../../../../../layout/Module';
import ChartSelector from './ChartSelector/ChartSelector';
import FilterStudents from './Filters/Button';
import SelectFieldCurriculum from '../../../../../FormControl/SelectCustom/SelectFieldCurriculum';
import { useGroupStudentsContext } from '../GroupStudentsContext/GroupStudentsContext';
import { MarkingList } from './CurriculumData/MarkingList';

const HeaderContent = ({}) => {
  const { curriculumId, onCurriculumChange } = useGroupStudentsContext();

  return (
    <Module.BodyHeader
      gap={2}
      className='border-b border-b-2 border-primary flex justify-start items-center relative'
      py={2}
    >
      <ChartSelector />
      <div
        className='flex justify-between items-center absolute top-0px bottom-0px right-0'
        style={{
          left: 'calc(150px + 1.5rem)'
        }}
      >
        <div className='flex items-center gap-2'>
          <SelectFieldCurriculum value={curriculumId} onChange={(e) => onCurriculumChange(e.target.value)} />
          <FilterStudents />
        </div>
        <MarkingList />
      </div>
    </Module.BodyHeader>
  );
};

export default HeaderContent;
